import request from '../../utils/request';

// 查询监控行为
export function getSensitiveBehavior(authorization, isloading = false){
  return request({
    url: '/api/statistic/chat/getsensitivebehavior',
    method: 'get',
    headers: {
      "authorization": authorization
    }
  }, isloading)
}

// 获取敏感行为图表
export function getBehaviorChart(params,authorization, isloading = false){
  return request({
    url: '/api/statistic/chat/msgtype',
    method: 'get',
    params,
    headers: {
      "authorization": authorization
    }
  }, isloading)
}

// 获取敏感行为员工图表
export function getBehaviorEmployee(params,authorization, isloading = false){
  return request({
    url: `/api/statistic/chat/employee`,
    method: 'post',
    data: params,
    headers: {
      "authorization": authorization
    }
  }, isloading)
}

// 触发敏感行为明细列表
export function getSensitiveEmployee(params,authorization, isloading = false){
  return request({
    url: '/api/statistic/chat/sensitiveemployee',
    method: 'post',
    data: params,
    headers: {
      "authorization": authorization
    }
  }, isloading)
}

// 获取所有监控行为
export function getAllSensitiveBehavior(authorization, isloading = false){
  return request({
    url: '/api/statistic/chat/getallmsgtypes',
    method: 'get',
    headers: {
      "authorization": authorization
    }
  }, isloading)
}
// 保存监控行为
export function saveSensitiveBehavior(params,authorization, isloading = false){
  return request({
    url: '/api/statistic/chat/savesensitivebehavior',
    method: 'post',
    data: params,
    headers: {
      "authorization": authorization
    }
  },isloading)
}
// 获取要提醒的员工
export function getStaffSensitive(authorization,isloading = false){
  return request({
    url: '/api/statistic/chat/getstaffsensitive',
    method: 'get',
    headers: {
      "authorization": authorization
    }
  },isloading)
}
// 保存要提醒员工
export function saveStaffSensitive(params,authorization,isloading= false){
  return request({
    url: '/api/statistic/chat/savestaffsensitive',
    method: 'post',
    data: params,
    headers: {
      "authorization": authorization
    }
  },isloading)
}



// -----------------------------------------------------
// 首页--客户联系统计
export function getCusChatDetail(params,authorization,isloading){
  return request({
    url: '/api/statistic/getCusChatDetail',
    method: 'post',
    data: params,
    headers: {
      "authorization": authorization
    }
  },isloading)
}
// 首页--获取聊天总数，发送消息数量，平局首次回复时
export function getEmpChatCusStatistic(params,authorization,isloading){
  return request({
    url: '/api/statistic/getEmpChatCusStatistic',
    method: 'get',
    params,
    headers: {
      "authorization": authorization
    }
  },isloading)
}
// 首页--获取累计绑定客户数，绑定答案数，客户总数
export function getCusHistoryData(authorization,isloading){
  return request({
    url: '/api/statistic/getCusHistoryData',
    method: 'get',
    headers: {
      "authorization": authorization
    }
  },isloading)
}

// 员工群聊概况
export function getgroupChatData(params,authorization,isloading){
  return request({
    url: '/api/statistic/group_chat/emp',
    method: 'post',
    data:params,
    headers: {
      "authorization": authorization
    }
  },isloading)
}
// 群聊趋势图
export function getnewGroupChatData(params,authorization){
  return request({
    url: '/api/statistic/group_chat/trend',
    method: 'get',
    params,
    headers: {
      "authorization": authorization
    }
  })
}
// 获取头部看板数据
export function getGroupChatDatas(params,authorization){
    return request({
      url: '/api/statistic/group_chat/data',
      method: 'get',
      params,
      headers: {
        "authorization": authorization
      }
    })
  }
//   群聊新增列表
export function getGroupChatAdd(params,authorization, isloading){
    return request({
      url: '/api/statistic/group_chat/add',
      method: 'post',
      data: params,
      headers: {
        "authorization": authorization
      }
    },isloading)
  }



